import { createContext, useContext } from 'react';
import { useVoiceChat } from '../hooks/useVoiceChat';

const VoiceChatContext = createContext();

export const useVoiceChatContext = () => {
  const context = useContext(VoiceChatContext);
  if (!context) {
    throw new Error('useVoiceChatContext must be used within VoiceChatProvider');
  }
  return context;
};

export const VoiceChatProvider = ({ children, conversationId }) => {
  const voiceChat = useVoiceChat(conversationId);

  return (
    <VoiceChatContext.Provider value={voiceChat}>
      {children}
    </VoiceChatContext.Provider>
  );
};